import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
  Button,
  VStack,
  Text,
  HStack,
  Card,
  CardBody,
  GridItem,
  IconButton,
} from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';
// @ts-ignore
import { HomeDashboard } from '../../screens/applications/components/dashboard.component';
import { BlueCheckApplication } from '../../utils/types';
import {
  updateAppActiveStep,
  updateAppEditAction,
  updateAppType,
} from '../../redux/appBuilder/stepperDetails';
import { useAppDispatch } from '../../redux/hooks';
import { deleteBlueCheckApplication } from '../../utils/bluecheck-applications/fetch-bluecheck-applications';
import { Dispatch, SetStateAction } from 'react';

interface ViewBlueCheckAppsProps {
  applications: BlueCheckApplication[];
  loading: boolean;
  noApplicationsFound: boolean;
  setAppDeleted: Dispatch<SetStateAction<boolean>>;
}
export const ViewBlueCheckApps = ({
  setAppDeleted,
  applications,
  loading,
  noApplicationsFound,
}: ViewBlueCheckAppsProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleEditClick = (id: string) => {
    dispatch(updateAppActiveStep(1));
    dispatch(updateAppEditAction(true));
    dispatch(updateAppType('BC_APP'));

    navigate(`/edit-application/${id}`);
  };

  const handleViewCode = (id: string) => {
    navigate(`/my-applications/bluecheck-code-preview/${id}`);
  };

  const handleDeleteClick = async (id: string) => {
    try {
      await deleteBlueCheckApplication(id);
      setAppDeleted((prev) => !prev);
    } catch (error) {
      console.error('Failed to delete application:', error);
    }
  };

  return (
    <>
      {noApplicationsFound ? (
        <VStack w="100%" justifyContent="center">
          <HomeDashboard heading="No Apps Found" showIllustration={false} />
        </VStack>
      ) : loading ? (
        <Text>Loading...</Text>
      ) : (
        <>
          {applications.map((app) => (
            <GridItem key={app.id}>
              <Card
                py={4}
                px={6}
                variant="filled"
                bgColor="#f7f9fb"
                borderRadius="16px"
                border="1.5px solid #f7f9fb"
                cursor={'pointer'}
                h={'190px'}
                _hover={{ borderColor: 'lightgray' }}
              >
                <CardBody
                  overflow="hidden"
                  onClick={() => {
                    handleEditClick(app.id);
                  }}
                  p={0}
                >
                  <VStack
                    align="flex-start"
                    w="100%"
                    h="100%"
                    spacing={1}
                    justifyContent="space-between"
                  >
                    <HStack
                      w="100%"
                      h="fit-content"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <VStack
                        w="80%"
                        align="flex-start"
                        justifyContent={'center'}
                        spacing={1.5}
                      >
                        <Text
                          className="small-font"
                          color="black"
                          fontFamily="inter"
                          maxWidth="85%"
                          isTruncated
                          title={app.metadataName}
                          style={{ fontWeight: 650 }}
                        >
                          {app.metadataName}
                        </Text>
                      </VStack>
                      <IconButton
                        aria-label="Delete Application"
                        icon={<DeleteIcon />}
                        colorScheme="red"
                        position="absolute"
                        top="4"
                        right="4"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(app.id);
                        }}
                      />
                    </HStack>
                    <Text color="gray.500" noOfLines={1}>
                      {app.id}
                    </Text>
                    <HStack
                      w="100%"
                      data-clickable="false"
                      justifyContent={'space-between'}
                    >
                      <Button
                        justifyContent="space-between"
                        bgColor="transparent"
                        p={0}
                        borderRadius="8px"
                        _hover={{ bgColor: 'transparent' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewCode(app.id);
                        }}
                        size="sm"
                      >
                        <Text
                          className="xx-small-font"
                          color="gray"
                          textDecoration="underline"
                          _hover={{ color: '#242323' }}
                          fontFamily="sans-serif"
                        >
                          View Code
                        </Text>
                      </Button>
                      <Button
                        variant="outline"
                        onClick={() => {
                          handleEditClick(app.id);
                        }}
                      >
                        <EditIcon
                          boxSize={3}
                          _hover={{ color: '#242323' }}
                          color="grey"
                          mr="4px"
                        />
                        <Text
                          className="xx-small-font"
                          color="grey"
                          textDecoration="underline"
                          _hover={{ color: '#242323' }}
                          fontFamily="sans-serif"
                        >
                          Edit
                        </Text>
                      </Button>
                    </HStack>
                  </VStack>
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </>
      )}
    </>
  );
};
